import { render, staticRenderFns } from "./confirmCode.vue?vue&type=template&id=2d21a4a2&scoped=true&"
import script from "./confirmCode.vue?vue&type=script&lang=js&"
export * from "./confirmCode.vue?vue&type=script&lang=js&"
import style0 from "./confirmCode.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./confirmCode.vue?vue&type=style&index=1&id=2d21a4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21a4a2",
  null
  
)

export default component.exports